import React, { Component } from 'react'
import PageBuilderAddElements from './PageBuilderAddElements'
import PageBuilderMain from './PageBuilderMain'
import { formBuilderGroups, FormBuilderObjects } from '../variables/formBuilderData'
import { widgetsList, widgetsGroups } from '../variables/widgetsList'
import inputComponents from '../components/inputs/inputComponents'
import WidgetComponents from '../components/widgets/WidgetComponents'
import ButtonAnimated from '../components/buttons/ButtonAnimated'
import HttpServices from '../utils/Http.services'
import { checkTranslation, translate } from '../utils/useful'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import ConfigView from './Applets/database/ConfigView'
import FixedView from '../components/FixedView'
import StagesManager from '../components/StagesManager'
import NavigationsView from './Applets/database/NavigationsView'
import PagePermissions from './CreateApplet/PagePermissions'
import Modal from '../components/Modal'
import FormViewer from '../components/FormViewer'

class PageBuilder extends Component {

    state = {
        view: true,
        type: 'dashboard',
        currentMedia: 'lg',
        componentsInfo: {
            form: { object: FormBuilderObjects, groups: formBuilderGroups, components: inputComponents },
            dashboard: { object: widgetsList, groups: widgetsGroups, components: WidgetComponents },
        },

        configPage: {
            headers: [

                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Page name', placeholder: '{{lang}}name' } },

                { key: 'background', type: 'ColorInput', col: '12', information: { label: '{{lang}}Page Background', placeholder: '{{lang}}background' } },
                // { key: 'affiliates', type: 'ApisInput', col: '12', information: { inputClass: 'bordered-input', label: '{{lang}}Initial Fetch ( For dynamic data )', hint: 'You can fetch data from APIs and collection and use their data as dynamic variables in the page,', placeholder: '{{lang}}Fetches' } },
                { key: 'path', type: 'PathInput', col: '12', information: { inputClass: 'bordered-input', label: '{{lang}}Page Path', placeholder: '{{lang}}Path' } },

                { key: 'fetches', type: 'ApisInput', col: '12', information: { inputClass: 'bordered-input', label: '{{lang}}Initial Fetch ( For dynamic data )', hint: 'You can fetch data from APIs and collection and use their data as dynamic variables in the page,', placeholder: '{{lang}}Fetches' } },

            ]
        },
        name: '',
        publishType: [
            { title: '{{lang}}Applet level', key: 'applet', icon: '/assets/icons/useful/applet.png', description: '{{lang}}This page will be available as a template in just this applet.' },
            { title: '{{lang}}Hub level', key: 'hub', icon: '/assets/icons/useful/hubs.png', description: '{{lang}}This page will be available as a template for all applets of this hub.' },
            { title: '{{lang}}Universal', key: 'universal', icon: '/assets/icons/useful/dashboard.png', description: '{{lang}}If Yonnect team approves this publish, this page will be available as a template for everyone in Yonnect.' },

        ],

        publishFields: [

            { key: 'media', type: 'ImageInput', col: '12', information: { label: '{{lang}}Media', placeholder: '{{lang}}media', required: true } },

            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: true } },

            { key: 'description', type: 'EditorInputNew', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true } },

            { key: 'tags', type: 'TagInput', col: '12', information: { label: '{{lang}}tags', required: false } },

        ],

        isLoadingData: false
    }

    componentDidMount() {

        this.init()
    }

    componentDidUpdate(prevProps) {
        if (this.props.windowData?.path[this.props.baseUrl?.length] != prevProps.windowData?.path[this.props.baseUrl?.length]) {
            this.init()
        }
    }


    init() {

        this.setState({ view: false }, () => {
            this.setState({ view: true }, () => {

                let _id = this.props.windowData?.path[this.props.baseUrl?.length]
                if (_id != "new" && _id != null) {
                    // GET PAGE
                    HttpServices.request('getFrame', { _id: _id }, (fetchResult, fetchError) => {

                        if (fetchError || !fetchResult || !fetchResult.info) {
                            return
                        }

                        this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name, page: fetchResult?.info }, () => {
                            if (this.props.setHeader) {

                                this.props.setHeader("dummy", 1)
                            }
                        })

                        // console.log(fetchResult?.info?.config?.fetches)

                        if (fetchResult?.info?.config?.fetches) {
                            this.getSingleContent(fetchResult?.info)
                        }
                    })
                }


            })
        })

    }



    getSingleContent(info) {

        let _id = this.props.windowData?.path[this.props.baseUrl?.length + 1]
        let fetchInfo = info?.config?.fetches


        if (Array.isArray(fetchInfo) ) {

            let fullData = {}


            let promises = []
            let fetchedData = []
            let params = []

            info?.config?.fetches.forEach(fetchInfo => {

                promises.push(new Promise((resolve) => {

                    // console.log(_id, fetchInfo)
                    if (_id) {

                        // let address = _id ? 'getSingleRecord' : 'getVariables'

                        HttpServices.request('getSingleRecord', { id: _id, collection: fetchInfo.collection }, (fetchResult, fetchError) => {

                            if (fetchError) {
                                resolve()
                                return
                            }


                            // console.log(fetchResult)
                            let fInfo = fetchInfo
                            fInfo.info = fetchResult.info
                            fInfo.frame = fetchResult.frame

                            fetchedData.push(fInfo)
                            fullData[fetchInfo.name] = fetchResult.info

                            let param = { label: fetchInfo.name, value: fetchInfo.value, fields: fetchResult.frame?.fields, info: fetchResult.info }

                            
                            params.push(param)

                            // console.log(params)
                            resolve()

                        })

                    } else {


                        HttpServices.request('getFrame', { _id: fetchInfo.collection }, (fetchResult, fetchError) => {

                            if (fetchError) {
                                resolve()
                                return
                            }


                            console.log(fetchResult)
                            let fInfo = fetchInfo
                            fInfo.info = {}//fetchResult.info
                            fInfo.frame = fetchResult

                            fetchedData.push(fInfo)


                            let param = { label: fetchInfo.name, value: fetchInfo.value, fields: fetchResult?.info?.fields, info: {} }

                            params.push(param)

                            resolve()

                        })
                    }

                }))




            });


            // promises.push(new Promise((resolve) => {

            //     if (_id && fetchInfo) {

            //         HttpServices.request('getVariables', { id: _id, collection: fetchInfo.collection }, (fetchResult, fetchError) => {

            //             resolve()

            //             if (fetchError) {
            //                 return
            //             }

            //             console.log(fetchResult)
            //             let fInfo = fetchInfo
            //             fInfo.info = fetchResult.info
            //             fInfo.frame = fetchResult.frame

            //             fetchedData.push(fInfo)

            //         })

            //     } else {
            //         resolve()
            //     }

            // }))


            Promise.all(promises).then(() => {

                console.log(fullData)
                // console.log(params)

                this.setState({ fetchedData, params,fullData })
            })

        }


    }



    setData = (key, value, reference, cb) => {
        if (reference == 'PageBuilder') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    afterPostDashboard = (fetchResult) => {
        let newLink = this.props.baseUrl.splice(2)
        newLink.push(fetchResult?.info?._id)
        this.props.changeWindowLink(newLink)
        this.setState({ _id: fetchResult?.info?._id })
        this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
    }


    toggleConfig = () => {
        // this.pageConfig.open()

        this.setState({ showConfig: !this.state.showConfig }, () => {

            if (this.state.showConfig) {
                this.setState({ initData: this.PageBuilderMain.state.content })
                if (this.props.setHeader) {
                    this.stageManager.changeStage('config')
                    this.props.setHeader("topHeaderComponent", this.topHeaderConfigComponent)

                }
            } else {
                if (this.props.setHeader) {
                    this.stageManager.changeStage('page')
                    this.props.setHeader("topHeaderComponent", this.topHeaderComponent)
                }
            }

        })
    }



    toggleNavigationMenu = () => {


        this.setState({ showNavigation: !this.state.showNavigation }, () => {

            if (this.state.showNavigation) {
                // if (this.props.setHeader) {
                this.stageManager.changeStage('navigation')
                // this.props.setHeader("topHeaderComponent", this.topHeaderConfigComponent)
                // }
            } else {
                // if (this.props.setHeader) {
                this.stageManager.changeStage('page')
                // this.props.setHeader("topHeaderComponent", this.topHeaderComponent)
                // }
            }

        })

    }

    togglePermissions = () => {

        this.setState({ showPermissions: !this.state.showPermissions }, () => {

            if (this.state.showPermissions) {
                this.stageManager.changeStage('permissions')
            } else {
                this.stageManager.changeStage('page')

            }
        })

    }


    togglePublish = () => {

        this.publishModal.showModal()
    }




    changeMedia = (media, cb) => {

        this.setState({ currentMedia: media }, () => {
            // this.props.setHeader("dummy", 1)
            if (cb) {
                cb()
            }
        })
        // this.PageBuilderMain.changeMedia(media)
    }






    setName = (value) => {
        this.setState({ name: value }, () => {
            this.props.setHeader("dummy", 1)

        })
    }

    save = (cb) => {
        let content = this.PageBuilderMain.state.content
        this.setState({ isLoadingData: true })
        if (this.state.name?.trim() == null || !this.state.name?.trim()) {
            this.setState({ name: null }, () => {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.NameRequired', description: '{{lang}}errors.NameRequired' })
                this.setState({ isLoadingData: false })
            })
        }
        if (content.length == 0) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.ContentEmpty', description: '{{lang}}errors.ContentEmpty' })
            this.setState({ isLoadingData: false })
        }
        if (this.state.name && this.state.name.trim() != null && content.length != 0) {
            // let pageId
            // if (this.props.windowData.path[5] && this.props.windowData.path[5] != 'new') {
            //     pageId = this.props.windowData.path[5]
            // }
            let data = {
                _id: this.state.page?._id,
                type: 'page',
                page: content,
                config: this.state.page?.config,
                menu: this.state.page?.menu

            }

            this.setState({ data }, () => {
                this.savePage(cb)
            })
        } else {
            cb()
        }
    }

    savePage = (cb) => {

        let data = this.state.data
        if (this.props.variables?.appletId) {
            data.applet = this.props.variables.appletId
        }
        let page = this.state.page ?? {}
        let isEditing = data._id ? true : false

        let currentId = this.props.windowData.path[this.props.windowData.path.length - 1]
        // console.log('page', page)
        // console.log('isEditing', this.props.baseUrl)
        // console.log('isEditing', this.props.windowData)

        let address = isEditing ? (this.props.page.editUrl ?? this.props.page.addUrl) : this.props.page.addUrl
        if (currentId && currentId != 'new') {
            data._id = this.props.windowData.path[this.props.windowData.path.length - 1]
        }
        this.setState({ isPostingData: true })
        if (page.postBody) {
            data = { ...data, ...page.postBody }
        }
        for (const [key, value] of Object.entries(data)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                if (this.props.variables) {
                    data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }
        for (const [key, value] of Object.entries(data)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                delete data[key]
            }
        }
        data.name = this.state.name.trim()
        // console.log('namebefore', data)
        // console.log('address', address)
        // console.log('nameafter', data.name)
        // console.log('datassss', data)
        // console.log('address', address, data)
        // console.log("Save Page22",data)

        HttpServices.request(address, data, (fetchResult, fetchError) => {

            // console.log(fetchResult, fetchError)
            // this.setState({ isPostingData: false })

            if (cb) {
                cb(fetchResult, fetchError)
            }
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError.message })
                return
            }

            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
            this.setState({ _id: fetchResult?.info?._id })

            let modules = this.props.modules

            // console.log(modules)
            // console.log(currentId)

            if (currentId && currentId == 'new') {
                modules.push(fetchResult.info)
            }
            this.setData('modules', modules, 'CollectionBaseAdminView')

            if (currentId && currentId == 'new') {
                let path = this.props.windowData.path
                path[this.props.windowData.path.length - 1] = fetchResult?.info?._id

                // console.log(path)
                this.props.changeWindow(path)
            }
            // this.props.changeWindowLink(newPath)
            // this.props.changeWindow(newPath)
            // let newLink = this.props.baseUrl.splice(2)
            // this.props.changeWindowLink(newLink)
            // this.setState({ isLoadingData: false })
        })
    }

    // onDragStartAction = (e, type) => {
    //     this.PageBuilderMain.onDragStartAction(e, type)
    // }

    applyConfig = () => {
        if (this.configView) {
            let data = this.configView.submitForm()
            if (data) {
                this.submitConfig()
            }

        }
    }

    submitConfig = (data) => {
        // console.log("submitConfig")
        // console.log(data)

        let page = this.state.page ?? {}
        page.config = data

        this.setState({ page }, () => {
            this.toggleConfig()
        })
    }


    submitMenu = (data) => {

        let page = this.state.page ?? {}
        page.menu = data
        console.log(page)
        this.setState({ page }, () => {
            this.toggleNavigationMenu()
        })
    }

    setPublishType = (prop) => {

        this.setState({ currentPublishType: prop }, () => {
            this.publishStageManager.changeStage('form')
        })

    }


    postPublish = () => {
        let data = this.publishForm.getForm()
        let type = this.state.currentPublishType
        let content = this.PageBuilderMain.state.content

        if (content.length == 0) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.ContentEmpty', description: '{{lang}}errors.ContentEmpty' })
            return
        }


        if (data) {

            this.setState({ isLoadingPublish: true })


            let body = data
            body.publishType = type.key
            // body.content = content
            // body.config = this.state.page?.config
            // body.menu = this.state.page?.menu
            body.refFrame = this.state.page._id


            HttpServices.request('publishTemplate', body, (fetchResult, fetchError) => {

                this.setState({ isLoadingPublish: false })

                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError.message })
                    return
                }

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
                this.publishStageManager.changeStage("success")


            })



        }
    }




    render() {

        let variables = { ...this.props.variables }
        variables.page = this.state.page ? { ...this.state.page } : null
        let currentMedia = this.state.currentMedia
        let width = this.props.width
        if (currentMedia == 'xs' && width > 550) {
            width = 550
        }
        if (currentMedia == 'md' && width > 780) {
            width = 780
        }
        // width = currentMedia == 'xs' ? 576 : (currentMedia == 'md' ? 780 : this.props.width)

        return (
            <div className='w-100 d-flex window-content-radius h-100 position-relative'>

                <StagesManager ref={el => this.stageManager = el} fast={true}  >

                    <div stage={0} stageName="page" className='w-100 h-100'>


                        <div className='w-100 h-100 d-flex' style={{ justifyContent: 'center', background: currentMedia != 'lg' ? 'repeating-linear-gradient(-55deg,#eee,#eee 10px,  #f0f0f0 10px,#f0f0f0 20px)' : null }}>


                            <div className='w-100 h-100 transition-all' style={{ maxWidth: currentMedia == 'xs' ? 550 : (currentMedia == 'md' ? 780 : '100%'), background: '#fff', boxShadow: currentMedia != 'lg' ? '0px 0px 30px #10101010' : null }}>
                                <PageBuilderMain baseUrl={this.props.baseUrl} windowData={this.props.windowData} functionsHandler={this.props.functionsHandler} setHeader={this.props.setHeader} changeWindow={this.props.changeWindow} initData={this.state.initData} params={this.state.params} componentsInfoForm={this.state.componentsInfo['form']} type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} ref={el => this.PageBuilderMain = el} width={width} height={this.props.height} colors={this.props.colors} changeWindowLink={this.props.changeWindowLink} changePage={this.props.changePage} pageChangePage={this.props.pageChangePage} applet={this.props.applet} editMode={true} addNewWindow={this.props.addNewWindow} variables={variables} padding={'10px 10px'} media={currentMedia} setName={this.setName} name={this.state.name} toggleNavigationMenu={this.toggleNavigationMenu} toggleConfig={this.toggleConfig} togglePermissions={this.togglePermissions} togglePublish={this.togglePublish} save={this.save} changeMedia={this.changeMedia} fullData={this.state.fullData} />
                            </div>
                            {/* <div className='w-100' style={{
                                display: 'flex',columnCount:3
                            }}>
                                <div style={{ flex:1, backgroundColor: '#007aff20' }}>
                                    <p>Text 1</p>
                                </div>

                                <div style={{ flex:1,flexBasis:'50%', backgroundColor: '#ee505020' }}>
                                    <p>Text 2</p>
                                </div>
                            </div> */}

                            {/* <div className='w-100' style={{
                                display: 'grid', gridTemplateColumns: 24,
                                gridTemplateColumns: 'minmax(calc( 4vw - 11px), 1fr) repeat(24, minmax(0, calc( ( 1500px - (11px * 23) ) / 24 ))) minmax(calc( 4vw - 11px), 1fr)',
                                gridTemplateRows: 'repeat(6,minmax(calc( min( 1500px , calc(100vw - 4vw * 2 - 0vw )) * 0.0215), auto))'
                            }}>
                                <div style={{ gridArea: '1 / 4 / span 4 / span 8', backgroundColor: '#007aff20' }}>
                                    <p>Text 1</p>
                                </div>

                                <div style={{ gridArea: '3 / 6', backgroundColor: '#ee505020' }}>
                                    <p>Text 2</p>
                                </div>
                            </div> */}
                            {/* <button onClick={()=>window.open('https://accounts.yonnect.com','_blank','toolbar=no,height=450,width=450,directories=no')}>
                                TEST WINDOW
                            </button> */}

                            {/* <PageBuilderMain initData={this.state.initData} componentsInfoForm={this.state.componentsInfo['form']} type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} ref={el => this.PageBuilderMain = el} width={this.props.width} height={this.props.height} colors={this.props.colors} /> */}
                        </div>

                    </div>

                    <div stage={1} stageName="config" className='w-100 h-100 position-absolute top-0 scroll-no-scrollbar' style={{ zIndex: 2, backgroundColor: '#fff', }}>

                        <ConfigView ref={el => this.configView = el} initData={this.state.page?.config} colors={this.props.colors} page={this.state.configPage} submitForm={this.submitConfig} cancel={this.toggleConfig} variables={variables} setHeader={this.props.setHeader} applyConfig={this.applyConfig} name={this.state.name} title={"{{lang}}Page settings"} />

                    </div>


                    <div stage={1} stageName="navigation" className='w-100 h-100 position-absolute top-0 scroll-no-scrollbar' style={{ zIndex: 2, backgroundColor: '#fff', }}>

                        <NavigationsView ref={el => this.navigationsView = el} initData={this.state.page?.menu} colors={this.props.colors} submitForm={this.submitConfig} cancel={this.toggleNavigationMenu} variables={variables} setHeader={this.props.setHeader} width={this.props.width} name={this.state.name} submitMenu={this.submitMenu} />

                    </div>


                    <div stage={1} stageName="permissions" className='w-100 h-100 position-absolute top-0 scroll-no-scrollbar' style={{ zIndex: 2, backgroundColor: '#fff', }}>

                        <PagePermissions continue={this.nextStage} baseUrl={this.props.baseUrl} initData={this.state.page} frames={this.props.frames} postCollection={this.props.postCollection} type={'FramePermissions'} cancel={this.togglePermissions} language={this.props.language} lastStage={this.props.lastStage} name={this.state.name} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} page={this.state.page} submitCollection={this.props.submitCollection} data={this.props.data} setData={this.setData} changeStage={this.props.changeStage} lastStagePage={this.props.lastStagePage} applet={this.props.applet} pages={this.props?.pages} width={this.props.width} height={this.props.height} stage={1} user={this.props.user} modules={this.props.modules} stageName={'FramePermissions'} changePage={this.props.changeStage} title={"Continue"} description={"Frame access"} route={this.props.route} variables={this.props.variables} functionsHandler={this.props.functionsHandler} changeWindowLink={this.props.changeWindowLink} />

                    </div>


                </StagesManager>


                <Modal maxWidth={400} ref={el => this.publishModal = el}>
                    <div className=" br-10" style={{ backgroundColor: '#fff', }}>


                        <StagesManager ref={el => this.publishStageManager = el} fast={true}  >
                            <div stage={0} stageName="type">

                                <div className=' px-3 py-2' style={{ borderBottom: "1px solid #eee" }}>
                                    {/* <img src='/assets/icons/useful/edit.png' width={20} alt='' /> */}
                                    <p className=' text-bold '>{translate("Select publish type")}</p>

                                </div>

                                <div className=' text-start py-2'>
                                    {this.state.publishType.map((prop, index) => {
                                        return (
                                            <button className='px-3 py-1 mb-2 text-start d-flex hover-gray-no-filter' key={index} onClick={() => this.setPublishType(prop)}>
                                                <div className='flexcc mrd-2 pt-1'>
                                                    <img src={prop.icon} width={20} alt='' />
                                                </div>
                                                <div>
                                                    <p className='text-normal text-bold'>{checkTranslation(prop.title)}</p>
                                                    <p className='text-smaller color-gray-1'>{checkTranslation(prop.description)}</p>
                                                </div>

                                                <div className='flexcc mld-2 pt-1'>
                                                    <img src={'/assets/icons/useful/arrow.svg'} width={30} alt='' />
                                                </div>


                                            </button>
                                        )
                                    })}
                                </div>

                                <div className='px-3 pb-3'>
                                    <div className='w-100 br-8 px-2 py-2' style={{ background: '#f2f2f2' }}>
                                        <p className=' text-smaller mt-1'>{translate("Publishing a page means, a template will be created from this page. your data and private information will not be shared and they are secure, just the page structure and configuration will be shared.")}</p>
                                        <p className='text-small text-link mt-1'>{translate("Learn more ")}</p>
                                    </div>
                                </div>

                            </div>




                            <div stage={1} stageName="form">

                                <div className=' px-3 py-2 flexc' style={{ borderBottom: "1px solid #eee" }}>
                                    <button className='flexcc mrd-2' onClick={() => this.publishStageManager.changeStage("type")}>
                                        <img className='rotate-0' src='/assets/icons/useful/fi-sr-angle-left.png' width={16} alt='' />
                                    </button>
                                    <p className=' text-bold '>{translate("Fill information about this page")}</p>

                                </div>

                                <div className=' text-start py-2 pt-3 px-1'>
                                    <FormViewer ref={el => this.publishForm = el} headers={this.state.publishFields} theme={"boreder-form"} inputClass={"bordered-input"} />

                                    <div className='flexce px-3 pb-4'>
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={() => { this.postPublish() }}
                                            title={translate('Publish as template')}
                                            icon='/assets/icons/plus-white.svg'
                                            textColor={this.props.colors?.textColor}
                                            invert={this.props.colors?.iconInvert}
                                            bg={this.props.colors?.background}
                                            isLoadingData={this.state.isLoadingPublish}
                                        />
                                    </div>
                                </div>


                            </div>



                            <div stage={1} stageName="success">

                                <div className=' px-4 py-2 pt-4 pb-3' style={{ borderBottom: "1px solid #eee" }}>

                                    <img className='rotate-0' src='/assets/icons/useful/confetti.png' width={40} alt='' />
                                    <p className=' text-bold '>{translate("Thanks you,")}</p>
                                    <p className=' text-bold mt-1'>{translate("Your request has been submitted successfully")}</p>
                                    <p className=' text-semibold text-small mt-2'>{translate("Page will be published completely, after Yonnect team reviews it.")}</p>

                                </div>

                                <div className=' text-start py-2 pt-3 px-1'>

                                    <div className='flexce px-3 pb-4'>
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={() => { this.publishModal.hideModal() }}
                                            title={translate('Close modal')}
                                            // icon='/assets/icons/plus-white.svg'
                                            textColor={this.props.colors?.textColor}
                                            invert={this.props.colors?.iconInvert}
                                            bg={this.props.colors?.background}
                                        />
                                    </div>
                                </div>


                            </div>


                        </StagesManager>



                    </div>


                </Modal>

            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageBuilder);